<template>
  <div class="flex w-full items-center justify-between space-x-4">
    <div class="w-11/12">
      <h2
        class="direction-text-truncate text-text-neutral-secondary text-base font-semibold"
      >
        {{ segmentDirectionText }}
      </h2>
      <p
        class="text-text-neutral-primary flex items-center space-x-2 text-xs font-medium"
      >
        <span>{{ segmentDateText }}</span>
        <span>•</span>
        <span class="flex space-x-1">
          <!--eslint-disable-next-line-->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
          >
            <path
              fill="#AEAEB2"
              d="M6.75 10.5A3.75 3.75 0 0 0 3 14.25a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 15 14.25a3.75 3.75 0 0 0-3.75-3.75h-4.5ZM9 1.5A3.75 3.75 0 1 0 9 9a3.75 3.75 0 0 0 0-7.5Z"
            />
          </svg>
          <span>{{ passengersAmount }}</span>
        </span>
      </p>
    </div>
    <AirlineIconsGroup :airlines="[segmentAirline]" />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { AirlineIconsGroup, type flightEntity } from 'freedom-shared';

  const props = defineProps<{
    segment: flightEntity.types.MappedSegment;
    passengersAmount: number;
  }>();

  const segmentDirectionText = computed(
    () => `${props.segment.dep.city} — ${props.segment.arr.city}`,
  );

  const segmentDateText = computed(
    () => `${props.segment.dep.dayOfMonth}, ${props.segment.dep.dayOfWeek}`,
  );

  const segmentAirline = computed(() => ({
    iata: props.segment.airline,
    title: '',
  }));
</script>

<style scoped>
  .direction-text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: -webkit-linear-gradient(left, #000 70%, #fff);
    -webkit-background-clip: text;
  }
</style>
